// extracted by mini-css-extract-plugin
module.exports = {"content":"e_Mr","opened":"e_Nr","buttonIcon":"e_Or","buttonIconOpen":"e_Pr","toggle":"e_Qr","collapsible":"e_Rr"};